"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypingEffectContainer = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const TypingEffectContainer = exports.TypingEffectContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TypingEffectContainer",
  class: "t1py7c3j",
  vars: {
    "t1py7c3j-1": [({
      centered
    }) => centered ? 'center' : 'flex-start']
  }
});